export const CUSTOM_ASPECT_RATIO_VALUE = 'custom';

/**
 * 判断某个 aspect_ratio 值是不是「用户填的自定义比例」。
 *
 * 判定依据是它不在当前模型的预设列表里，而不是格式——预设本身就是 "16:9" 这种形状，
 * 靠格式没法区分。`custom` 是选项占位符，不是真实比例值。
 */
export const isCustomAspectRatioValue = (value: string | undefined, availableRatios: readonly string[]): boolean =>
  !!value && value !== CUSTOM_ASPECT_RATIO_VALUE && !availableRatios.includes(value);

/**
 * 把 "宽:高" 拆成两个数字，供弹窗回填。
 *
 * 注意别写成 `value.split(':').map(Number.parseInt)`——map 会把下标当第二个实参传给
 * parseInt 当基数，高度会以 1 为基数解析成 NaN。
 */
export const parseCustomAspectRatio = (value: string | undefined): { wide?: number; high?: number } => {
  const [wide, high] = (value ?? '').split(':').map((part) => Number.parseInt(part, 10));
  if (!Number.isFinite(wide) || !Number.isFinite(high) || wide <= 0 || high <= 0) {
    return {};
  }

  return { wide, high };
};
